import React, { Component } from 'react';
import { ModalHeader } from 'reactstrap';
import { IconButton,Badge,Grid,Chip,CircularProgress,Snackbar,Dialog,Slide, Typography, DialogContent, withStyles, DialogActions,Divider } from '@material-ui/core';
import IntlMessages from 'util/IntlMessages';
import Widget from "components/Widget/index";
import NotEditor from './notEditor'
import AttachFileIcon from '@material-ui/icons/AttachFile';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import Close from '@material-ui/icons/Close';
import isEmpty from 'lodash/isEmpty'
import MuiAlert from '@material-ui/lab/Alert';
import SaveBtn from './SaveBtn';
import {isUndefined} from 'lodash'
import NoteAltOutlinedIcon from '@mui/icons-material/NoteAltOutlined';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import {checkMalewares} from 'actions'
import FindInPageIcon from '@mui/icons-material/FindInPage';
import BugReportIcon from '@mui/icons-material/BugReport';
import WarningFileContainMaleware from './WarningFileContainMaleware'
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const mapDispatchToProps= (dispatch) => {
  return {
    checkMalewares:(file,callBackfunc) => dispatch(checkMalewares(file,callBackfunc)),
    dispatch
  }
}
const mapStateToProps = ({accountsData}) => {
  const {fileMessage,FileCheck,FileCheckWarning} = accountsData
  return {
    fileMessage,FileCheck,FileCheckWarning
  };
}


const styles = theme => ({ 
  dialog:{
    padding: 0
  }
});

class index extends Component {
    
    state = {
        handelse:{
            text:"",
            AttachFile:[]
        },
        scanDocument:"",
        isLoading: false,
        message: "",
        isOpen: false,
        showMessage:false,
        fullScreen: false
    };
 


    handleAddPost() {
        this.setState({
            handelse:{
                AttachFile:[],
                text:""
            },
            
        });
    }
    handleupdatecommentText=(commentText)=>{
      if(!isUndefined(this.props.onChange)) {
        this.props.onChange(commentText)
      } else {
        this.setState({
            handelse:{
                ...this.state.handelse,
                text:commentText
            }
        })
      }
    }
    onChange(e) {
        this.setState({ handelse:{text: e.target.value } })
    }
    getThisFileName=(e)=>{
      console.log(e.target.files[0],"FFFFiles")
      this.setState({
        ...this.state,
        scanDocument:e.target.files[0].name
      })
      this.props.checkMalewares(e.target.files[0],()=>{
        this.setState({
          handelse:{
              ...this.state.handelse,
              scanDocument:"",
           AttachFile: [
              ...this.state.handelse.AttachFile,
              e.target.files[0],
          ]
      }
      })
      })
        
    }
    handleDelete = (fileToDelete) => {
        let AttachFileN = this.state.handelse.AttachFile.filter((file) => file.name !== fileToDelete.name)
        this.setState({
            handelse:{
                ...this.state.handelse,
                AttachFile: AttachFileN
            }
        })
    }
    sendThisState = () => {
        this.props.saveAnteck(this.state.handelse)
        this.setState({
            handelse:{
                text:"",
                AttachFile:[]
            },
            isLoading:this.props.isLoading,
            message:"",
            showMessage:false,
            fullScreen: false
        })   /**/
    }
    componentDidUpdate =()=>{
        if(this.state.isLoading !== this.props.isLoading){
            this.setState({
                isLoading:this.props.isLoading,
                message: this.props.message,
                showMessage:true

            })
        }
    }
    handleRequestClose = () => {
        this.setState({
          showMessage: false,
          message:''
        });
      };
      handleOpen = () => {
        this.setState({fullScreen: true})
      }
      handleClose = () => {
        this.setState({fullScreen: false})
      }
    render() {
      const {classes} = this.props
       // const { classes } = this.props;
        const { handelse } = this.state;
        const isEnabled = !handelse.AttachFile.length === 0 || !isEmpty(handelse.text);
        let BodyHeight = 561;
        handelse.AttachFile.map(n=>
            BodyHeight+=35
        )
        return (
            <>
                {
                  this.props.hideFullscreen ? '' : 
                  
                  <div style={{ padding: '1rem' }}>
                    <div  className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        <NoteAltOutlinedIcon className={'text-dark text-primary'}/>
                        <h4 className="font-weight-bold text-dark ml-1 mb-0" style={{whiteSpace: 'pre-wrap', wordBreak: 'break-all'}}>{this.props.title}</h4>
                      </div>
                      <IconButton color="primary" size='small' onClick={this.handleOpen}>
                          <FullscreenIcon />
                      </IconButton>
                  </div>
                    <Divider className='mt-2'/>
                  {/* <div className="d-flex align-items-center">
                    <CheckBoxOutlinedIcon className={'text-dark text-primary'}/>
                    <h4 className="font-weight-bold text-dark ml-1 mb-0" style={{whiteSpace: 'pre-wrap', wordBreak: 'break-all'}}>{this.props.title}</h4>
                  </div> */}
                  </div>
                }
                <div>
                <div>
                    <div>
                        <div>
                        <div>
                          <NotEditor disabled={this.props.disabled} 
                          commentText={isUndefined(this.props.Body) ? handelse.text : this.props.Body} 
                          handleupdatecommentText={this.handleupdatecommentText}
                          /> 
                          <Grid container style={{ padding: '0rem 1rem 0.5rem 0.5rem' }}>
                              <Grid item md="8">   
                                {
                                  this.props.disabled ? '' :
                                  isUndefined(this.props.hiddenAttachBtn) ? 
                                  <div className="d-flex align-items-center w-100">
                                    <label htmlFor="icon-button-file">
                                      <IconButton style={{ color: '#0D7C82' }} size='small' aria-label="upload picture" 
                                      component="div">
                                          <AttachFileIcon />
                                      </IconButton>
                                      <input  id="icon-button-file" type="file" 
                                      style={{ display:"none"}} onChange={this.getThisFileName}/> 
                                    </label>
                                    {
                                      this.props.FileCheck === true?
                                      <Badge
                                      anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                      }}
                                      badgeContent={
                                        <BugReportIcon style={{fontSize:17,color:"#f00"}}/>
                                      }>                                     
                                       {this.state.scanDocument} <FindInPageIcon style={{fontSize:30}} color={"primary"}/>
                                      </Badge>
                                      :""
                                      }
                                    {
                                    handelse.AttachFile.map((n)=>{
                                    // let icon;
                                        return (
                                            <Chip
                                            label={n.name}
                                            color="primary"
                                            size="small"
                                            onDelete={()=>this.handleDelete(n)}
                                            className="ml-2 my-1"
                                            />
                                        )
                                        })   
                                    }
                                  </div> : ''
                                }
                                </Grid>
                              
                              <Grid item md="4" className="text-right my-auto">
                                {
                                  isUndefined(this.props.hiddenSaveBtn) ? 
                                  <SaveBtn isEnabled={isUndefined(this.props.Body)?isEnabled:true} sendThisState={this.sendThisState} /> : ''
                                }
                              </Grid>
                              <Grid item md="12">
                             
                              </Grid>
                          </Grid>
                    </div>
                     
                  </div>
                </div>
              </div>
            </div>
            
            <Dialog fullScreen open={this.state.fullScreen} onClose={this.handleClose} TransitionComponent={Transition}>
              <ModalHeader className="modal-box-header bg-primary text-white">
                <IntlMessages id="Label.New.note" />
                <IconButton className="text-white"
                    onClick={this.handleClose}>
                    <Close />
                </IconButton>
            </ModalHeader>
            <DialogContent dividers classes={{root: classes.dialog}} >
              
              <NotEditor height={1} disabled={this.props.disabled} commentText={isUndefined(this.props.Body) ? handelse.text : this.props.Body} handleupdatecommentText={this.handleupdatecommentText}/> 
              <Grid container style={{ padding: '0rem 1rem 0.5rem 0.5rem' }}>
                <Grid item md="8">
                  {
                    this.props.disabled ? '' :
                    isUndefined(this.props.hiddenAttachBtn)  ? 
                    <div className="d-flex align-items-center w-100">
                    <label htmlFor="icon-button-file">
                      <IconButton style={{ color: '#0D7C82' }} size='small' aria-label="upload picture" 
                      component="div">
                          <AttachFileIcon />
                      </IconButton>
                      <input  id="icon-button-file" type="file" 
                      style={{ display:"none"}} onChange={this.getThisFileName}/> 
                    </label>
                    {
                                      this.props.FileCheck === true?
                                      <Badge
                                      anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                      }}
                                      badgeContent={
                                        <BugReportIcon style={{fontSize:17,color:"#f00"}}/>
                                      }>                                     
                                       {this.state.scanDocument} <FindInPageIcon style={{fontSize:30}} color={"primary"}/>
                                      </Badge>
                                      :""
                                      }
                    {
                    handelse.AttachFile.map((n)=>{
                    // let icon;
                        return (
                            <Chip
                            label={n.name}
                            color="primary"
                            size="small"
                            onDelete={()=>this.handleDelete(n)}
                            className="ml-2 my-1"
                            />
                        )
                        })   
                    }
                  </div> : ''
                  }
                
                </Grid>
                <Grid item md="4" className="text-right my-auto">
                  {
                    isUndefined(this.props.hiddenSaveBtn) ? 
                    <SaveBtn isEnabled={isUndefined(this.props.Body)?isEnabled:true} 
                    sendThisState={this.sendThisState} /> : '' 
                  }
                </Grid>
                <Grid item md="12">
                 
                </Grid>
            </Grid>
            </DialogContent>
            {
              this.props.FileCheckWarning === true?
              <WarningFileContainMaleware
              scanDocument={this.state.scanDocument}
              />
              :""
            }
            {/* <DialogActions>
              <div className="col-6">
                  <div className="form-group mb-0">
                    <Button
                      variant="outlined"
                      color="secondary"
                      size="small"
                      onClick={this.handleClose}
                    >
                      <IntlMessages id="Cancel"/>
                    </Button>
                  </div>
              </div>
              <div className="col-6 d-flex justify-content-end">
                  <div className="form-group mb-0">
                    <Button
                    disabled={!isEnabled}
                      variant='contained'
                      color="primary"
                      size="small"
                      onClick={this.sendThisState}
                    >
                      <IntlMessages id="Add"/>
                    </Button>
                  </div>
              </div>
          </DialogActions> */}
            </Dialog>
          </>
        );
    }
}

export default compose(
  connect(mapStateToProps,mapDispatchToProps),
  withStyles(styles)
)(index)